$(document).ready(function () {
  var hr = window.location.href
  if (hr.indexOf('discountcode') >= 0) {
    //set cookie
    function setCookie(name, value, days) {
      var d = new Date()
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
      document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
    }
    var parser = document.createElement('a')
    parser.href = window.location.href
    var query = parser.search.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      if (vars[i].indexOf('discountcode') >= 0) {
        var pair = vars[i].split('=')
        var discode = pair[1]
      }
    }
    setCookie('discount_code', discode)
  }
  if (hr.includes('#how-it-works')) {
    window.scrollBy(0, -150)
  }
  //get cookie
  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    return v ? v[2] : null
  }

  if (getCookie('discount_code')) {
    $('.ann_wp').hide()
    var APIurl =
      'https://app.trynood.com/api/get-discount-code?shop=' +
      Shopify.shop +
      '&discount_code=' +
      getCookie('discount_code')
    function dt(APIurl, method) {
      var settings = {
        async: true,
        crossDomain: true,
        url: APIurl,
        method: method,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
      return settings
    }
    $.ajax(dt(APIurl, 'GET')).done(function (response) {
      var data = response.data
      var countDownDate = new Date(data.discount_code.ends_at).getTime()
      var x = setInterval(function () {
        var now = new Date().getTime()
        var distance = countDownDate - now
        var days = Math.floor(distance / (1000 * 60 * 60 * 24))
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        hours = hours + days * 24
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        if (minutes < 10 && minutes >= 00) {
          minutes = '0' + minutes
        }
        var seconds = Math.floor((distance % (1000 * 60)) / 1000)
        if (seconds < 10 && seconds >= 00) {
          seconds = '0' + seconds
        }
        document.getElementById('timer').innerHTML = ' ' + hours + ' h ' + minutes + ' m ' + seconds + ' s '
        if (distance < 0) {
          clearInterval(x)
          $('.offer_announce').hide()
          $('.ann_wp').show()
        } else {
          $('.offer_announce').show()
          $('.ann_wp').hide()
        }
      }, 1000)
      var moneyFormatt = $('body').attr('data-money_format')
      function formatMoneyy(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '')
        }

        var value = ''
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
        var formatString = format || moneyFormatt
        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ','
          decimal = decimal || '.'
          if (isNaN(number) || number === null) {
            return 0
          }
          number = (number / 100.0).toFixed(precision)
          var parts = number.split('.')
          var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
          var centsAmount = parts[1] ? decimal + parts[1] : ''
          return dollarsAmount + centsAmount
        }
        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2)
            break
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0)
            break
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',')
            break
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',')
            break
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ')
            break
          case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'")
            break
        }
        return formatString.replace(placeholderRegex, value)
      }
      if ($('body').hasClass('template-cart')) {
        $('[action="/cart"]').append('<input type="hidden" name="discount" value="' + data.discount_code.title + '">')
      }
      $('.offer_announce .cname').text(data.customer.first_name + ' ' + data.customer.last_name)
      $('.offer_announce .discount_code').text(data.discount_code.title)
      if (data.discount_code.value_type == 'percentage') {
        $('.offer_announce .discount_value').text(data.discount_code.value + '% Off')
      } else {
        $('.offer_announce .discount_value').text(
          formatMoneyy(parseInt(data.discount_code.value * 100), moneyFormatt) + ' Off'
        )
      }
      $('.offer_announce').show()
      $('#NavDrawer').css({ top: $('.announce_wp').outerHeight() + $('.site-header').innerHeight() - 5 })
      // $('#NavDrawer').css({'height': 'calc(100% - '+($('.announce_wp').outerHeight() + $('.site-header').innerHeight() - 5)+'px)'});
    })
  } else {
    $('.ann_wp').show()
    $('#NavDrawer').css({ top: $('.announce_wp').outerHeight() + $('.site-header').innerHeight() - 5 })
    // $('#NavDrawer').css({'height': 'calc(100% - '+($('.announce_wp').outerHeight() + $('.site-header').innerHeight() - 5)+'px)'});
  }
})

document.addEventListener('DOMContentLoaded', () => {
  let ratingFromApp = document.querySelector('.ruk_rating_snippet')
  const ratingText = document.querySelector('#reviewNumber')
  ratingFromApp.addEventListener('load', function () {
    const title = ratingFromApp.title
    console.log(title)
    newRatingText = title.split('Stars')[0]
    const roundedRating = Math.round(parseFloat(newRatingText) * 10) / 10
    ratingText.innerText = roundedRating
  })
})

function getFocusableElements($container) {
  return Array.from(
    $container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
  ).filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'))
}

function trapFocus($container) {
  const focusableElements = getFocusableElements($container)
  const firstFocusable = focusableElements[0]
  const lastFocusable = focusableElements[focusableElements.length - 1]

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault()
        lastFocusable.focus()
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault()
        firstFocusable.focus()
      }
    }
  })

  setTimeout(() => {
    firstFocusable.focus()
  }, 100)
}

function removeTrapFocus($container) {
  window.removeEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault()
        lastFocusable.focus()
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault()
        firstFocusable.focus()
      }
    }
  })
}
